import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { firstAllowedPath } from "../lib/permissions";
import AdminDashboardPage from "../pages/admin/DashboardPage";

export function RequirePermission({ feature, action = "view", children }) {
  const { admin, can } = useAuth();

  if (!admin) return children;

  if (!can(feature, action)) {
    const fallback = firstAllowedPath(admin);
    if (!fallback) {
      return (
        <div className="rounded-3xl bg-white border border-black/5 p-8">
          <h1 className="font-display text-3xl">No access</h1>
          <p className="text-sm text-black/55 mt-2">
            This account has not been granted any dashboard permissions. Ask a superadmin to update your roles and permissions.
          </p>
        </div>
      );
    }
    return <Navigate to={fallback} replace />;
  }

  return children;
}

export function AdminHome() {
  const { admin, can } = useAuth();
  if (!admin) return null;
  if (can("overview", "view")) return <AdminDashboardPage />;
  const fallback = firstAllowedPath(admin);
  if (!fallback || fallback === "/admin") {
    return (
      <div className="rounded-3xl bg-white border border-black/5 p-8">
        <h1 className="font-display text-3xl">No access</h1>
        <p className="text-sm text-black/55 mt-2">
          This account has not been granted any dashboard permissions. Ask a superadmin to update your roles and permissions.
        </p>
      </div>
    );
  }
  return <Navigate to={fallback} replace />;
}
